import type { ActiveDealRow } from '@metycle/shared';

import type { FinancingPartner } from '../lib/financing-partners';
import { useBlLevelRowPatch } from './use-bl-level-row-patch';

export interface AssignFinancingPartnerVariables {
  blOrderId: string;
  financing_partner: FinancingPartner | null;
  sold_date: Date | null;
}

function toIsoDate(date: Date | null): string | null {
  return date === null ? null : date.toISOString().slice(0, 10);
}

function toBody(variables: AssignFinancingPartnerVariables): Record<string, unknown> {
  return {
    financing_partner: variables.financing_partner,
    sold_date: toIsoDate(variables.sold_date),
  };
}

function applyOptimistic(
  row: ActiveDealRow,
  variables: AssignFinancingPartnerVariables,
): ActiveDealRow {
  return {
    ...row,
    financing_partner: variables.financing_partner,
    sold_date: toIsoDate(variables.sold_date),
  };
}

export function useAssignFinancingPartner() {
  return useBlLevelRowPatch<AssignFinancingPartnerVariables>({ toBody, applyOptimistic });
}
